import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import setAuthHeader from "utils/set-auth-header";

const initialState = {
  token: null,
  _id: null,
  name: null,
  email: null,
  authSet: false,
  answers: null,
  picture: null,
  submissionTimestamps: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(checkAuth.pending, (state, action) => {})
      .addCase(checkAuth.fulfilled, (state, action) => {
        const { token, _id, name, email, role, answers, picture, submissionTimestamps } =
          action.payload;
        state.token = token;
        state._id = _id;
        state.name = name;
        state.email = email;
        state.role = role;
        state.answers = answers;
        state.authSet = true;
        state.picture = picture;
        state.submissionTimestamps = submissionTimestamps;

        if (token) {
          localStorage.setItem("UBAY_TOKEN", token);
          setAuthHeader(token);
        }
      })
      .addCase(checkAuth.rejected, (state, action) => {
        console.log(action.payload);
        localStorage.removeItem("UBAY_TOKEN");
        setAuthHeader();
      });
  },
  reducers: {
    setUser: (state, action) => {
      const { token, _id, name, email, role, authSet, picture, answers, submissionTimestamps } =
        action.payload;
      state.token = token;
      state._id = _id;
      state.name = name;
      state.email = email;
      state.role = role;
      state.picture = picture;
      state.answers = answers;
      state.submissionTimestamps = submissionTimestamps;
      if (typeof authSet !== "undefined") state.authSet = authSet;

      if (token) {
        localStorage.setItem("UBAY_TOKEN", token);
        setAuthHeader(token);
      }
    },

    removeUser: (state, action) => {
      state._id = null;
      state.email = null;
      state.token = null;
      state.email = null;
      state.role = null;
      state.answers = null;
      state.picture = null;
      state.submissionTimestamps = null;
      localStorage.removeItem("UBAY_TOKEN");
      setAuthHeader();
    },

    updateAnswers: (state, action) => {
      state.answers = action.payload.answers;
      if (action.payload.submissionTimestamps) {
        state.submissionTimestamps = action.payload.submissionTimestamps;
      }
    },
  },
});

export default authSlice.reducer;

export const { setUser, removeUser, updateAnswers } = authSlice.actions;

export const checkAuth = createAsyncThunk("auth/checkAuth", async () => {
  const token = localStorage.getItem("UBAY_TOKEN");
  try {
    setAuthHeader(token);
    const response = await axios.get("/auth/get-user");

    return { ...response?.data?.user, token };
  } catch (err) {
    console.log(err);
    toast.error("Something went wrong! You are being logged out automatically");
    throw err?.response?.data;
  }
});
